import { render, staticRenderFns } from "./CanalCobroDelete.vue?vue&type=template&id=559989a0"
import script from "./CanalCobroDelete.vue?vue&type=script&lang=js"
export * from "./CanalCobroDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports